<template>
  <v-form ref="numberPortabilityRef" class="px-4 pt-2">
    <v-row v-for="(number, index) in localValue" :key="index" no-gutters>
      <v-col cols="3">
        <v-text-field
          v-model="number.prefix"
          label="Vorwahl"
          :rules="mandatory"
          density="compact"
          variant="underlined"
          class="pr-4"
        >
          <template #label>
            Vorwahl <sup v-if="mandatory" class="required">*</sup>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="number.number"
          variant="underlined"
          label="Nummer"
          :rules="mandatory"
          append-icon="mdi-delete"
          density="compact"
          @click:append="localValue.splice(index, 1)"
        >
          <template #label>
            Nummer <sup v-if="mandatory" class="required">*</sup>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-btn
      v-if="portablePhoneNumbers.length < 10"
      variant="tonal"
      prepend-icon="mdi-plus-thick"
      class="my-4"
      @click="addNewLine"
    >
      Weitere Rufnummern hinzufügen
    </v-btn>
    <v-alert
      v-else
      color="orange"
      density="compact"
    >
      Es können maximal 10 Rufnummern portiert werden
    </v-alert>
  </v-form>
</template>

<script setup lang="ts">
import { computed, ref, reactive } from 'vue';
import type { PhoneNumber } from '../../types/common';
import { mandatory } from '../../composables/validations';

const modelValue = defineModel<PhoneNumber[]>({ required: true });

const numberPortabilityRef = ref();
const portablePhoneNumbers = reactive<PhoneNumber[]>([
  {
    number: '',
    prefix: '',
  },
]);

const localValue = computed<PhoneNumber[]>({
  get: () => modelValue.value,
  set: value => {
    modelValue.value = value;
  },
});

async function addNewLine() {
  const { valid } = await numberPortabilityRef.value.validate();
  if (!valid) {
    return;
  }

  localValue.value.push({ number: '', prefix: '' });
}

if (localValue.value.length === 0) {
  localValue.value.push({ number: '', prefix: '' });
}
</script>
